import React from 'react';
import { useTranslation } from 'react-i18next';
import { Icon, Button, ModalWrapper, ModalCloseButton } from '../common';


/**
 * Figma: 프라이빗 이동, 프라이빗 투어>예약 대기 안내
 * Desktop: 500x363, Mobile: 380x385
 * Shows when selected date is fully booked
 */
function formatDateTime(raw) {
  if (!raw) return raw;
  const [datePart, timePart] = raw.split('T');
  if (!timePart) return raw;
  return `${datePart} ${timePart}`;
}

export default function ReservationWaitingModal({ date, onClose, onSelectOtherDate, onRegisterWaiting, registering }) {
  const { t } = useTranslation();
  return (
    <ModalWrapper padding="pt-5 px-5 pb-10" gap="gap-2.5">
      {/* Close Button */}
      <div className="flex justify-end">
        <ModalCloseButton onClick={onClose} />
      </div>

      {/* Icon Circle */}
      <div className="flex justify-center">
        <div className="w-16 h-16 rounded-full bg-mono-50 flex items-center justify-center">
          <Icon name="alert" size={52} className="text-mono-500" />
        </div>
      </div>

      {/* Date */}
      <p className="text-sm font-medium text-orange-500 text-center mt-2">
        {formatDateTime(date) || ''}
      </p>

      {/* Title */}
      <h2 className="text-xl font-bold text-mono-900 text-center">
        {t('common.date_closed_title')}
      </h2>

      {/* Description */}
      <p className="text-sm font-medium text-mono-900 text-center leading-[22.4px] break-keep">
        {t('common.date_closed_desc')}
      </p>

      {/* Buttons */}
      <div className="flex gap-2.5 mt-4">
        <Button level="level3" fullWidth onClick={onSelectOtherDate}>{t('common.select_other_datetime')}</Button>
        <Button level="level1" fullWidth onClick={onRegisterWaiting} disabled={registering}>{registering ? t('common.registering') : t('common.waiting_register')}</Button>
      </div>
    </ModalWrapper>
  );
}
